import styled from 'styled-components';
import BREAK_POINTS from 'packages/smart-home-support/styling/media-queries';

export default styled.div`
  margin-bottom: 4px;
  font-weight: 600;
  color: white;
  font-size: 16px;
  text-align: center;
  @media ${BREAK_POINTS.desktop} {
    font-size: 18px;
  }
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/SignupSubtitle.tsx